// GA4 conversion event tracking — safe no-op when the Google tag hasn't loaded.
export function trackEvent(name, params = {}) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", name, params);
  }
}
